import httpRequest from "../utils/httpRequest";
import { get, omit } from "lodash";
import API_URLS from "../../src/utils/apiUrls";
import { objectToParams } from "../../src/utils/helper";

const _ = { get, omit };

export const updateCandidate = (payload: any) => {
  return httpRequest()
    .patch(`${API_URLS.candidates}update`, payload)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const candidateApplyJob = ({ id, formData }: any) => {
  return httpRequest()
    .patch(`${API_URLS.jobApplications}apply/${id}`, formData)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const candidateSaveJob = (payload: any) => {
  return httpRequest()
    .patch(`${API_URLS.jobApplications}save/${payload}`)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const candidateJobApplicationList = (payload: any) => {
  const params = objectToParams(payload);
  return httpRequest()
    .get(`${API_URLS.jobApplications}?${params}`)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
        pagination: _.get(res, "data.pagination", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const companyCandidatesList = (fields: any) => {
  //full BE route api/company/candidates/list
  return httpRequest()
    .get(`${API_URLS.candidates}list`, fields)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: true,
        message: _.get(
          err,
          "response.data.message",
          "Something went wrong fetching company candidates"
        ),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const uploadCandidateFile = (payload: any) => {
  const type = _.get(payload, "type", "image");
  const formData = _.get(payload, "payload", {});
  return httpRequest()
    .post(`${API_URLS.candidates}profile/${type}`, formData)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const deleteVideo = () => {
  return httpRequest()
    .delete(`${API_URLS.candidates}profile/video`)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const fetchCandidatePublicProfile = (slug: string) => {
  return httpRequest()
    .get(`${API_URLS.candidates}profile/public/${slug}`)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};
export const updateCandidateBasicInfo = (form_Data: any) => {
  return httpRequest()
    .patch(`${API_URLS.candidates}profile/basic-profile`, form_Data)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "data.message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};
export const updateCandidatePersonalValue = (payload: any) => {
  return httpRequest()
    .patch(`${API_URLS.candidates}profile/personal-value`, payload)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const updateCandidateProfessionalPassion = (payload: any) => {
  const formData = _.get(payload, "payload", {});
  return httpRequest()
    .patch(`${API_URLS.candidates}profile/professional-passion`, formData)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};
export const updateCandidateWorkingExperience = (payload: any) => {
  const formData = _.get(payload, "experiences", {});
  return httpRequest()
    .patch(`${API_URLS.candidates}profile/work-experience`, formData)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const updateCandidateProjects = (payload: any) => {
  const formData = _.get(payload, "projects", {});
  return httpRequest()
    .patch(`${API_URLS.candidates}profile/projects`, formData)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};
export const updateCandidateSkills = (payload: any) => {
  const formData = _.get(payload, "skills", {});
  return httpRequest()
    .patch(`${API_URLS.candidates}profile/skills`, formData)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};
export const updateCandidateEducation = (payload: any) => {
  const formData = _.get(payload, "education", {});
  return httpRequest()
    .patch(`${API_URLS.candidates}profile/education`, formData)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const updateCandidateAccomplishment = (payload: any) => {
  const formData = _.get(payload, "accomplishments", {});
  return httpRequest()
    .post(`${API_URLS.candidates}profile/accomplishments`, formData)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const updateCandidateCertificates = (payload: FormData) => {
  return httpRequest()
    .post(`${API_URLS.candidates}profile/certificates`, payload)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "data.message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

// social links
export const updateCandidateSocialLinks = (payload: any) => {
  const formData = _.get(payload, "social_links", {});
  return httpRequest()
    .post(`${API_URLS.candidates}profile/social-link`, {
      social_links: formData,
    })
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

// add services

export const updateCandidateServices = (payload: any) => {
  return httpRequest()
    .post(`${API_URLS.candidates}profile/services`, payload)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const updateCandidateVisibility = (payload: any) => {
  return httpRequest()
    .patch(`${API_URLS.candidates}profile/visibility`, payload)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "data.message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const deactivateAccount = (payload: any) => {
  return httpRequest()
    .patch(`${API_URLS.candidates}deactivate-account`, payload)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "data.message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const deleteAccount = (payload: any) => {
  return httpRequest()
    .patch(`${API_URLS.candidates}delete-account`, payload)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "data.message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const updateNotifications = (payload: any) => {
  return httpRequest()
    .patch(`${API_URLS.candidates}update-notifications`, payload)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "data.message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const updateSlug = (payload: any) => {
  return httpRequest()
    .put(`${API_URLS.candidates}profile/slug`, payload)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "data.message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const uploadCandidateResume = (payload: any) => {
  const formData = _.get(payload, "payload", {});
  return httpRequest()
    .post(`${API_URLS.candidates}profile/resume`, formData)
    .then((res) => {
      const body = _.get(res, "data", {});
      const data = _.get(body, "data", body);
      return {
        flag: true,
        message: _.get(body, "message", ""),
        resumeParsedMessage: _.get(body, "resumeParsedMessage", ""),
        data,
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const parseCandidateResume = (payload: any) => {
  const formData = _.get(payload, "payload", {});
  return httpRequest()
    .post(`${API_URLS.candidates}profile/resume-parse`, formData)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.parsed", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

/** PATCH resume: pass metadata object for visibility/primary only, or FormData to replace file + metadata */
export const updateCandidateResume = (
  id: number,
  payload: { resume_visibility?: number; is_primary?: number } | FormData
) => {
  return httpRequest()
    .patch(API_URLS.updateResume(id), payload)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const deleteCandidateResume = (id?: number) => {
  const url =
    id != null && id > 0
      ? API_URLS.deleteUpload(id)
      : `${API_URLS.candidates}profile/resume`;
  return httpRequest()
    .delete(url)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const uploadCandidateBanner = (payload: any) => {
  return httpRequest()
    .post(`${API_URLS.candidates}profile/banner`, payload)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.parsed", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

// recommendations

export const getRecommendations = () => {
  return httpRequest()
    .get(`${API_URLS.candidates}profile/recommendation`, {})
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const postRecommendations = (payload: any) => {
  return httpRequest()
    .post(`${API_URLS.candidates}profile/recommendation`, payload)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

/** Ask a connection for a recommendation (LinkedIn-style request). */
export const requestRecommendation = (payload: any) => {
  return httpRequest()
    .post(`${API_URLS.candidates}profile/recommendation/request`, payload)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

/** Decline an “ask for recommendation” request or submit text via alternate client (action: decline | write). */
export const respondRecommendationRequest = (payload: any) => {
  return httpRequest()
    .put(`${API_URLS.candidates}profile/recommendation/response/request`, payload)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const deleteRecommendations = (id: any) => {
  return httpRequest()
    .delete(`${API_URLS.candidates}profile/recommendation/${id}`)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const updateRecommendations = (id: any, payload: any) => {
  return httpRequest()
    .put(`${API_URLS.candidates}profile/recommendation/update/${id}`, payload)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const approveRecommendations = (payload: any) => {
  return httpRequest()
    .put(`${API_URLS.candidates}profile/recommendation/response`, payload)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const markPublicRecommendations = (payload: any) => {
  return httpRequest()
    .put(`${API_URLS.candidates}profile/recommendation/is-public`, payload)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "data.message", ""),
        data: _.get(res, "data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const requestUpdateRecommendations = (payload: any) => {
  return httpRequest()
    .put(`${API_URLS.candidates}profile/recommendation/requestRevise`, payload)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};

export const declineReviseRecommendation = (payload: any) => {
  return httpRequest()
    .put(`${API_URLS.candidates}profile/recommendation/reviseResponse`, payload)
    .then((res) => {
      console.log({ res });
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      console.log({ err });

      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};


export const updateSocialUser = (form_Data: any) => {
  return httpRequest()
    .patch(`${API_URLS.candidates}profile/social-user`, form_Data)
    .then((res) => {
      return {
        flag: true,
        message: _.get(res, "message", ""),
        data: _.get(res, "data.data", {}),
      };
    })
    .catch((err) => {
      return {
        flag: false,
        message: _.get(err, "response.data.message", "Something went wrong!"),
        errors: _.get(err, "response.data.errors", {}),
      };
    });
};
const candidateServices = {
  updateCandidate,
  companyCandidatesList,
  uploadCandidateFile,
  candidateApplyJob,
  deleteVideo,
  fetchCandidatePublicProfile,
  candidateJobApplicationList,
  candidateSaveJob,
  updateCandidateEducation,
  updateCandidateAccomplishment,
  updateCandidateCertificates,
  updateCandidateSkills,
  updateCandidateProjects,
  updateCandidateWorkingExperience,
  updateCandidateProfessionalPassion,
  updateCandidatePersonalValue,
  updateCandidateBasicInfo,
  updateCandidateVisibility,
  deactivateAccount,
  deleteAccount,
  updateNotifications,
  updateSlug,
  uploadCandidateResume,
  updateCandidateResume,
  deleteCandidateResume,
  parseCandidateResume,
  updateSocialUser,
  updateCandidateSocialLinks,
  updateCandidateServices,
  uploadCandidateBanner,
  getRecommendations,
  postRecommendations,
  requestRecommendation,
  respondRecommendationRequest,
  deleteRecommendations,
  updateRecommendations,
  approveRecommendations,
  markPublicRecommendations,
  requestUpdateRecommendations,
  declineReviseRecommendation,
};

export default candidateServices;
